<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";
    import {UrlUtil} from "../../../lib/Common/Http/UrlUtil";
    import {HttpRequestUtil} from "../../../lib/Common/Http/HttpRequestUtil";
    import {MessageStore} from "../../../store/MessageStore";
    import InputAreaView from "../../../component/common/Form/InputAreaView.svelte";

    const dispatcher = createEventDispatcher();

    export let space;

    let name = '';
    let description = '';
    let manualUrl = '';
    let slackNoticeAccessToken = '';
    let slackNoticeChannelId = '';

    let logoFiles = [];
    let isDeleteLogo = false;

    onMount(() => {
        name = space.name;
        description = space.description;
        manualUrl = space.manual_url;
        slackNoticeAccessToken = space.slack_notice_access_token;
        slackNoticeChannelId = space.slack_notice_channel_id;
    });

    function saveData() {
        const formData = new FormData();
        const paramMap = {};
        formData.append('id', space.id);
        formData.append('name', name);
        if (description != null) {
            formData.append('description', description);
        }
        if (manualUrl != null) {
            formData.append('manual_url', manualUrl);
        }
        if (slackNoticeAccessToken != null) {
            formData.append('slack_notice_access_token', slackNoticeAccessToken);
        }
        if (slackNoticeChannelId != null) {
            formData.append('slack_notice_channel_id', slackNoticeChannelId);
        }

        if (isDeleteLogo) {
            formData.append('delete_logo_file', undefined);
        } else {
            if (logoFiles.length > 0) {
                console.log({logoFiles});
                const logoFile = logoFiles[0];
                formData.append('logo_file', logoFile);
            }
        }

        const url = UrlUtil.createApiUrl("space");


        HttpRequestUtil.postRequest(url, formData, (response) => {

            console.log(response);
            const body = response['body'];
            const space = body['space'];

            dispatcher('update', {space: space});

        });
    }

    function onClickSave() {
        MessageStore.showConfirmInformationYesNo("更新してもよろしいですか？", () => {
            saveData();
        })
    }


</script>


<div class="space-setting-view">

    <fieldset>
        <legend>基本情報</legend>

        <div class="input-area">
            <div class="row">
                <InputAreaView label="名前">
                    <input type="text"
                           class="input-name" placeholder="○○スペースの表示名(改行可)"
                           bind:value={name}
                    />
                </InputAreaView>

            </div>
            <div class="row">
                <InputAreaView label="説明">
                    <textarea class="input-description" placeholder="○○プロジェクトのスペースです"
                              bind:value={description}
                    />
                </InputAreaView>
            </div>

            <div class="row">
                <fieldset>
                    <legend>Slack通知</legend>
                    <InputAreaView label="アクセストークン">
                        <input type="text" class="slack-access-token" placeholder="アクセストークン"
                               bind:value={slackNoticeAccessToken}/>
                    </InputAreaView>
                    <InputAreaView label="チャンネルID">
                        <input type="text" placeholder="チャンネルID" bind:value={slackNoticeChannelId}/>

                    </InputAreaView>

                </fieldset>
            </div>


        </div>


        <div class="logo-area">
            <div class="file-area">
                <label>
                    スペースロゴ画像(png)

                    <input type="file" accept="image/png"
                           bind:files={logoFiles}
                           disabled={isDeleteLogo}
                    />
                </label>

                <label>
                    <input type="checkbox" bind:checked={isDeleteLogo}/>
                    ロゴファイルを削除
                </label>


            </div>
            <div class="tips">
                ※ この画像はスペース一覧でも表示されます。リリース前のタイトルの場合は、指定しないことをおすすめします。
            </div>
        </div>


        <div class="button-area">
            <button class="primary" on:click={onClickSave}>
                保存
            </button>
        </div>
    </fieldset>


</div>
<style lang="scss">
    .space-setting-view {
        .input-area {

            .row {
                display: flex;
                gap: 12px;

                margin-top: 8px;

                .slack-access-token {
                    width: 36em;
                }

                .input-description {
                    width: 30em;
                }

                .input-manual-url {
                    width: 60em;
                }
            }

        }

        .logo-area {
            margin-top: 32px;

            .file-area {
                display: flex;
                align-items: center;
            }

            .tips {
                font-size: 0.7em;
                opacity: 0.7;
            }

        }

        .button-area {
            margin-top: 32px;
        }
    }
</style>